import React from 'react';
import styled, { css } from 'styled-components';

import { isNotNullish } from '@tager/web-core';

import DetailedCarPreviewSpecification from '@/components/DetailedCarPreviewSpecification';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import {
  PreviewCodeItems,
  PreviewSvgIconItems,
} from '@/components/DetailedCarPreviewSpecification/DetailedCarPreviewSpecification.types';
import { svgIconItem } from '@/modules/DetailedCar/DetailedCar.helper';
import { media } from '@/utils/mixin';
import { CarsStockFuel } from '@/services/stock/enums';

function PreviewSpecification() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    params: {
      fuel,
      body,
      gearbox,
      wheel,
      electricEnginesCount,
      engineCapacity,
      enginePower,
      engineSecondPower,
      distanceLimit,
      batteryCapacity,
    },
  } = data;

  const previewItems = [
    data.params.fuel
      ? {
          label: 'Двигатель',
          svgIcon: svgIconItem(data.params.fuel?.id),
          value: `${
            electricEnginesCount ? `Количество: ${electricEnginesCount},` : ''
          } 
      ${engineCapacity ? engineCapacity + ' л,' : ''} 
      ${
        enginePower
          ? enginePower +
            ' л.с' +
            (engineSecondPower ? '/' + engineSecondPower + ' л.c,' : ',')
          : ''
      } 
      ${fuel?.label ?? ''}`,
          code: PreviewCodeItems.ENGINE,
        }
      : undefined,
    (fuel?.id === CarsStockFuel.Electric ||
      fuel?.id === CarsStockFuel.Hybrid) &&
    distanceLimit
      ? {
          label: 'Запас хода',
          svgIcon: PreviewSvgIconItems.DEFAULT,
          value: distanceLimit + ' км',
          code: PreviewCodeItems.DISTANCE_LIMIT,
        }
      : body?.label
      ? {
          label: 'Тип кузова',
          svgIcon: svgIconItem(body?.id),
          value: body.label,
          code: PreviewCodeItems.BODY_TYPE,
        }
      : undefined,
    (fuel?.id === CarsStockFuel.Electric ||
      fuel?.id === CarsStockFuel.Hybrid) &&
    batteryCapacity
      ? {
          label: 'Батарея',
          svgIcon: PreviewSvgIconItems.DEFAULT,
          value: batteryCapacity + ' кВт*ч',
          code: PreviewCodeItems.BATTERY,
        }
      : gearbox?.label
      ? {
          label: 'Коробка передач',
          svgIcon: svgIconItem(gearbox?.id),
          value: gearbox.label,
          code: PreviewCodeItems.GEARBOX,
        }
      : undefined,
    wheel?.label
      ? {
          label: 'Привод',
          svgIcon: svgIconItem(wheel?.id),
          value: wheel.label,
          code: PreviewCodeItems.TRANSMISSION,
        }
      : undefined,
  ]
    .filter(isNotNullish)
    .filter((item) => item.value.trim());

  if (!previewItems || previewItems.length === 0) {
    return null;
  }

  return (
    <Component>
      <DetailedCarPreviewSpecification items={previewItems} />
    </Component>
  );
}

export default PreviewSpecification;

const Component = styled.div`
  margin-top: 40px;

  ${media.mobile(css`
    margin-top: 20px;
  `)}
`;
